import { render } from "./App.vue?vue&type=template&id=cd952f2e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cd952f2e&lang=css"
script.render = render

export default script